import { CommonConfirmDialog } from '@/components/Common/CommonConfirmDialog';

type RemoveAttachmentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const RemoveAttachmentModal = ({
  isOpen,
  onClose,
  onConfirm,
}: RemoveAttachmentModalProps) => {
  return (
    <CommonConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      icon="fa-light fa-trash-can"
      title="Remove attachment?"
      content="Are you sure you want to remove this attachment?"
      confirmButtonText="Remove"
      onConfirm={onConfirm}
    />
  );
};
